import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Profile from '../Pages/Profile'

function  ProfileLayout() {
  return (
    <>
    <Header />
    <Profile />
    <Footer />
    </>
  )
}

export default ProfileLayout